module.exports = __webpack_public_path__ + "img/star.e4712f4c.svg";